import { render, staticRenderFns } from "./Festival.vue?vue&type=template&id=3f2c519a&scoped=true&"
import script from "./Festival.vue?vue&type=script&lang=js&"
export * from "./Festival.vue?vue&type=script&lang=js&"
import style0 from "./Festival.vue?vue&type=style&index=0&id=3f2c519a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f2c519a",
  null
  
)

export default component.exports